/**
 * THE FIELDS ON OFFER — one line each, keyed by the id the AUTHORITY offers (`server/scenarios.ts`).
 *
 * The key is the id and never the name: a field renamed in the menu would quietly lose its line, and a
 * missing line reads as a field nobody bothered to describe. What each one SAYS is written to be judged
 * from the list — what you will find there, and what it deliberately does not have.
 */
export default {
  practice: 'A range with the distances marked out: figures at 10, 20, 30, 40, 50 and 60 m, plates, balloons and cover at three heights.',
  forest300plus: 'Conifers with clearings, denser towards the edges, and a 300 m track down the western flank with a convoy on it.',
  plain300: 'The same field without a single tree: low cover, long lines of fire and nothing to hide behind.',
  airport: 'A 300 × 300 aerodrome: the west end built, its taxiway annex and parked aircraft, the housing and the fence.',
  mountain: 'A mountainside with its road: 474 m of track climbing 39 m, oaks and birches on the slope, rocks and a cliff. 300 × 300 with 76 m of relief, and 91 % of it walkable.',
  calibracion: 'An empty bench: one copy of whichever body you pick per piece being calibrated, marcadoras and gear, each standing in the act its weld was authored against.',
};
